export const REQUIRED_FILES = 2;

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

// Customer.io allows 2 MB of base64 attachments per email (~1.5 MB raw for
// both files) and PDFs are not compressed by sharp, unlike images
export const MAX_PDF_FILE_SIZE = 700 * 1024; // 700 KB

export const PDF_MIME_TYPE = 'application/pdf';

export const ACCEPT_FILE_TYPES = {
  'image/heic': [],
  'image/heif': [],
  'image/jpeg': [],
  'image/png': [],
  'image/webp': [],
  [PDF_MIME_TYPE]: ['.pdf'],
};

export const ACCEPTED_FILE_FORMATS = Object.keys(ACCEPT_FILE_TYPES).join(', ');
